// extracted by mini-css-extract-plugin
export default {"buttonClass":"StyledModal-module--buttonClass--OgXjW","containerModal":"StyledModal-module--containerModal--lPdLm"};